export enum ErrorCode {
  EXISTINGACCOUNT = "1001",
  USERNOTVALID = "3001",
}
